// ============================================================================
// FWSSP production probe — cassetto attrezzi diagnostico
// ----------------------------------------------------------------------------
// Intercetta CLIENT-SIDE, su traffico reale, le chiamate FreeWheel SSP e l'esito
// dell'asta Prebid. Accumula CONTATORI AGGREGATI per-sessione e fa UN SOLO flush
// (increment atomico) su Firebase Realtime DB al pagehide → costo ~0.
//
// Orchestratore: monta i singoli attrezzi. Setup/lettura/costi → README.md.
//   config.ts       configurazione + matcher
//   sink.ts         contatori + flush su Firebase
//   networkProbe.ts attrezzo 1: VAST grezza (empty/has_ad/has_sticky)
//   eventFunnel.ts  attrezzo 2: funnel eventi Prebid (requested/bid/nobid/...)
// ============================================================================

import { FWSSP_PROBE } from "./config";
import { installFlush } from "./sink";
import { installNetworkProbe } from "./networkProbe";
import { installEventFunnel } from "./eventFunnel";

export { FWSSP_PROBE } from "./config";

/**
 * Installa il probe (idempotente). Va chiamato il prima possibile, prima che
 * parta l'asta, così il wrap di rete cattura anche la prima chiamata FreeWheel.
 */
export function initFwsspProbe(): void {
  if (!FWSSP_PROBE.enabled || !FWSSP_PROBE.dbUrl) return;
  if (typeof window === "undefined") return;
  const w = window as any;
  if (w.__fwsspProbeInstalled) return;
  w.__fwsspProbeInstalled = true;

  installNetworkProbe();
  installEventFunnel();
  installFlush();
}
